import NavBar from "../components/Navbar/NavBar"
import { Helper } from "../static/helper"
import Footer from "../components/Footer"
import ScrollToTop from '../components/ScrollToTop';

export const FormationChiropracteur = () => {

    const webSite = () => {
        window.open(Helper.urlReservation)
    }

    return <>
        <div>
            <NavBar />
        </div>

        <ScrollToTop>

        <div className="min-h-screen bg-gray-50">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 lg:pt-32 pb-12">

                <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8 lg:p-12">
                    <h1 style={{ color: Helper.footerBackGroundColor }} className="font-bold text-2xl sm:text-3xl lg:text-4xl text-center mb-8">
                        Formation du Chiropracteur
                    </h1>

                    <div className="space-y-6 text-gray-600 text-base sm:text-lg leading-relaxed">
                        <div className="bg-gray-50 rounded-xl p-6">
                            <h2 className="font-semibold text-gray-800 text-lg mb-3">Une formation rigoureuse et intensive</h2>
                            <p>
                                L'IFEC propose un programme de formation de <strong className="text-gray-800">5 000 heures</strong>, réparties sur cinq années académiques, soit un total de <strong className="text-gray-800">300 crédits ECTS</strong>. Ce cursus combine des enseignements théoriques et pratiques.
                            </p>
                        </div>

                        <p>
                            L'enseignement général est dispensé par des <strong className="text-gray-800">docteurs en médecine</strong>, des chiropracteurs, des universitaires, des docteurs en sciences (PhD) et des enseignants chercheurs.
                        </p>

                        <p>
                            Le parcours inclut de nombreux <strong className="text-gray-800">stages cliniques et hospitaliers</strong>, dont un stage clinique de 15 mois en 5e année, effectué dans l'un des Centres cliniques de chiropraxie de l'Institut.
                        </p>

                        <div className="bg-gray-50 rounded-xl p-6 my-8">
                            <h2 className="font-semibold text-gray-800 text-lg mb-3">Diplôme reconnu</h2>
                            <p className="text-gray-700">
                                À la fin de cette formation, l'étudiant obtient le <strong>diplôme de Chiropracteur</strong>, reconnu par le Ministère de la Santé, qui lui confère le droit d'exercer sous le titre de Chiropracteur sur le territoire national.
                            </p>
                            <p className="text-gray-700 mt-3">
                                Ce diplôme délivré par l'IFEC permet également d'exercer la chiropraxie dans l'<strong>Union Européenne</strong>, sous réserve de respecter les réglementations locales.
                            </p>
                        </div>
                    </div>

                    <div className="flex justify-center mt-10">
                        <button style={{ background: Helper.footerBackGroundColor }} className="text-white font-semibold px-8 py-4 rounded-xl shadow-lg hover:opacity-90 transition-opacity" onClick={webSite}>
                            Prendre rendez-vous
                        </button>
                    </div>
                </div>

            </div>
        </div>

        <Footer />

        </ScrollToTop>
    </>
}
